import { gql } from '@apollo/client';

export const previewUpgradeToUltraQuery = gql`
  query ECOMMERCE_previewUpgradeToUltra($input: UpgradeToUltraInput!) {
    previewUpgradeToUltra(input: $input) {
      subtotalInCents
      shippingInCents
      taxInCents
      totalInCents
      activationFeesInCents
      appliedDiscountInCents
      cartItemCredits {
        cartItemId
        creditReason
        creditAmountInCents
      }
    }
  }
`;

export const purchaseUpgradeToUltraMutation = gql`
  mutation ECOMMERCE_purchaseUpgradeToUltra($input: UpgradeToUltraInput!) {
    purchaseUpgradeToUltra(input: $input) {
      chargeInvoice {
        number
      }
      isReturningCustomer
    }
  }
`;
